import { apiClient } from '@/utils/api'

// Season Bracket - an instance of a bracket template activated for a specific season
export interface SeasonBracket {
  bracketId: string
  seasonId: string
  leagueId: string
  groupId: string
  templateId: string
  name: string
  description?: string
  displayOrder: number
  createdAt: string
  updatedAt: string
}

interface SeasonBracketsResponse {
  data: SeasonBracket[]
  meta: {
    total: number
  }
}

interface SeasonBracketResponse {
  data: SeasonBracket
}

export const bracketService = {
  // List all brackets activated for a specific season
  async list(leagueId: string, seasonId: string): Promise<SeasonBracket[]> {
    const response = await apiClient.authGet<SeasonBracketsResponse>(
      `/leagues/${leagueId}/seasons/${seasonId}/brackets`
    )
    return response.data
  },

  // Get a single bracket by ID
  async get(bracketId: string): Promise<SeasonBracket> {
    const response = await apiClient.authGet<SeasonBracketResponse>(
      `/brackets/${bracketId}`
    )
    return response.data
  },

  // Activate a bracket template for a season
  async create(
    leagueId: string,
    seasonId: string,
    data: { templateId: string; name?: string; description?: string; displayOrder?: number }
  ): Promise<SeasonBracket> {
    const response = await apiClient.authPost<SeasonBracketResponse>(
      `/leagues/${leagueId}/seasons/${seasonId}/brackets`,
      data
    )
    return response.data
  },

  // Update a season bracket (can customize name, description, displayOrder)
  async update(
    bracketId: string,
    data: { name?: string; description?: string; displayOrder?: number }
  ): Promise<SeasonBracket> {
    const response = await apiClient.authPut<SeasonBracketResponse>(
      `/brackets/${bracketId}`,
      data
    )
    return response.data
  },

  // Remove a bracket from a season
  async delete(leagueId: string, seasonId: string, bracketId: string): Promise<void> {
    await apiClient.authDelete(`/leagues/${leagueId}/seasons/${seasonId}/brackets/${bracketId}`)
  },

  // List brackets for a season in a public group (no auth)
  async listPublic(leagueId: string, seasonId: string): Promise<SeasonBracket[]> {
    const response = await apiClient.get<SeasonBracketsResponse>(
      `/leagues/${leagueId}/seasons/${seasonId}/brackets/public`
    )
    return response.data
  },
}
